<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">
        {{ location }}
      </h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.inventory.detail.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.inventory.detail.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box dark color="outline" class="col-4 col-lg-auto p-1"
          :title="$t('lang.inventory.detail.box_title_1')"
        >
          <template slot="actions">
            <bx-inventory-status
              :status="inventory.state"
            ></bx-inventory-status>
          </template>
          <div class="detail-titles">
            <div class="wrapper">
              <h4>
                Nº
                <strong>{{ inventory.id }}</strong>
              </h4>
              <h5>
                <strong>{{ inventory.start_time }}</strong>
              </h5>
            </div>
          </div>
        </bx-box>

        <bx-box dark color="outline" class="col-4 col-lg-auto p-1"
        :title="$t('lang.inventory.detail.box_title_2')">
          <bx-complementary
          v-if="inventory.items"
            :total="Math.abs(inventory.theorical_stock)"
            :left="{ value: inventory.items }"
            :right="{ value: inventory.theorical_stock - inventory.items }"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.common.articles')"
            :value="ordersCount"
            font-size="xs"
            v-if="!shouldLoading"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.epc.area_location')"
            :value="inventory.location_area"
            font-size="xs"
            v-if="!shouldLoading"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-4 col-lg-auto p-1">
          <bx-btn
            class="col-lg-12 bx-tag bx-uppercase rounded-pill btn-validation"
            style="padding: 12px 12px 12px 8px; margin-top: 15px"
            color="green"
            block
            v-if= "!shouldLoading && !validationMode && inventory.state===0"
            @click="onClick('sendValidation')"
            >{{ $t("lang.inventory.detail.btn_validation_pending") }}</bx-btn>
          <span
            class="inventory-status"
            block
            v-else-if="!shouldLoading && !validationMode && inventory.state===2"
          >
            <div
              class="col-lg-11 bx-tag rounded-pill bx-bg-color-lime bx-uppercase text-center btn-validation"
              style="padding: 12px 12px 12px 8px; margin-top: 15px"
            >
              {{ $t("lang.inventory.detail.btn_validation_done") }}
            </div>
          </span>
        </bx-box>

        <bx-box dark color="outline" class="col-4 col-lg-auto p-1">
          <bx-btn
            class="col-lg-12 bx-tag bx-uppercase rounded-pill btn-validation"
            style="padding: 12px 12px 12px 8px; margin-top: 15px"
            color="orange"
            block
            v-if="!shouldLoading && !validationMode && inventory.state<=1"
            @click="onClick('sendUnvalidation')"
            >{{ $t("lang.inventory.detail.btn_validation_cancel") }}</bx-btn
          >
        </bx-box>
      </div>
      <skeleton-boxes progress-box :boxes="6" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <v-row class="d-flex d-sm-none">
          <v-list width="100%">
            <v-list-item
              two-line
              v-for="(item, index) in data"
              :key="index"
              class="green lighten-5 ma-2 rounded-lg"
              ripple
            >
              <v-list-item-content>
                <v-list-item-title>
                  <div>{{ item.gtin }}</div>
                </v-list-item-title>
                <v-list-item-subtitle>{{ item.section }}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">{{item.season}}</v-list-item-subtitle>
              </v-list-item-content>
              
              <v-list-item-action>
                <v-list-item-subtitle class="text-caption">
                  {{ item.quantity + "/" + item.theorical_quantity }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption"> {{ item.colour }} </v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">{{ item.model }} </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-row>
        <div class="row">
          <div class="col-12">
            
            <bx-box
              :title="`DETALLE DEL INVENTARIO`"
              no-padding
              :loading="shouldLoading"
            >
            <div class="form-row d-flex align-items-end">


            <div class="select-box col-md-6">
              <v-select
                v-model="filteringInventory"
                :items=filterOptions
                v-if="!shouldLoading"
                item-value="value"
                v-on:change="getData"
                :label="$t('lang.inventory.detail.btn_filtering_items')"
                outlined
              ></v-select>
            </div>
          </div>
              <skeleton-table :columns="9" v-if="shouldLoading" />
              <bx-table
                v-if="!shouldLoading"
                :data="data"
                :columns="columns"
                paginated
                backendPagination
                :currentPage="page"
                @search="onSearch"
                :total="ordersCount"
                :perPage="itemsPerPage"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column field="gtin" centered>
                  <router-link
                    :to="{
                      name: 'inventory-gtin',
                      params: { gtin: props.row.gtin }
                    }"
                    class="bx-link bx-link-bold"
                  >
                    {{ props.row.gtin }}
                  </router-link>
                </bx-table-column>
                  <bx-table-column field="description" centered>{{
                    props.row.description
                  }}</bx-table-column>
                  <bx-table-column field="season" centered>{{
                    props.row.season
                  }}</bx-table-column>
                  <bx-table-column field="section" centered>{{
                    props.row.section
                  }}</bx-table-column>
                  <bx-table-column field="model" centered>{{
                    props.row.model
                  }}</bx-table-column>
                  <bx-table-column field="size" centered>{{
                    props.row.size
                  }}</bx-table-column>
                  <bx-table-column field="colour" centered>{{
                    props.row.colour
                  }}</bx-table-column>
                  <bx-table-column centered>
                    <bx-complementary-mini
                      :left="props.row.theorical_quantity"
                      :more="props.row.ismore"
                      :percent="props.row.stockRatingPercent"
                    ></bx-complementary-mini>
                  </bx-table-column>
                  <bx-table-column field="quantity" centered>
                    <strong class="bx-text-color-lime">{{
                      formatQty(props.row.quantity)
                    }}</strong>
                  </bx-table-column>
                </template>
              </bx-table>
            </bx-box>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="confirmDialog" persistent scrollable width="600px">
      <v-card>
        <v-card-title>
          <h4 class="mt-3 w-100 text-left">
            {{
              mode === "sendValidation"
                ? $t("lang.inventory.detail.confirm_validation")
                : $t("lang.inventory.detail.confirm_cancelation")
            }}
          </h4>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-10" color="#9bc31c" @click="onCancel" dark>
            No
          </v-btn>
          <v-btn class="mr-5" color="#9bc31c" @click="onConfirmation" dark>
            {{ $t("lang.inventory.detail.yes") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BxComplementaryMini from "../../bx-components/BxComplementaryMini";
import BxInventoryStatus from "../../bx-components/BxInventoryStatus";
import BxBtn from "../../bx-components/BxBtn";

let filterOptions = [
  { value: 0, text: "Desactivado" },
  { value: 1, text: "Items faltantes" },
  { value: 2, text: "Items excedentes"}
];

export default {
  name: "inbound-dashboard",
  components: { BxComplementaryMini, BxInventoryStatus, BxBtn },
  props: {
    id: {
      type: [Number, String],
    },
  },
  data() {
    return {
      key: "inventory_detail",
      shouldLoading: true,
      columns: [],
      isdark: true,
      filterOptions: filterOptions,
      data: [],
      ordersCount: 1,
      inventory: {},
      validationMode: false,
      page: 1,
      itemsPerPage: 25,
      data_users: [],
      filters: [],
      confirmDialog: false,
      filteringInventory: 0,
      mode: "",
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    },
  },
  methods: {
    onSearch(field, value) {
      this.$session.set(this.key + field, value);
      this.filters[field] = value;
      this.getData();
    },
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    parseSizes(sizes){
      if (sizes === null || sizes === undefined) { // true
        return ""
      } else {
        let size_list=[]
        sizes.forEach(size => size_list.push(size.country + "/" + size.value))
        if (size_list.length == 0) {
          size_list = ""
        } else {
          size_list = size_list.toString().replace("[", "").replace("]", "").replace("--", "Standard")
        }
        return size_list
      }
    },
    async getData() {
      this.inventory = await this.$api.inventories.get(this.id);
      this.data_users = await this.$api.inventories.users(this.id);
      var data = [];
      if (this.filteringInventory == 1) {
        data = await this.$api.inventories.remaining_summary(this.id, {
          item_type__gtin__contains: this.filters.gtin,
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage,
        });
      } else if (this.filteringInventory == 2) {
        data = await this.$api.inventories.surplus_summary(this.id, {
          item_type__gtin__contains: this.filters.gtin,
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage
        })
      } else {
        data = await this.$api.inventories.summary(this.id, {
          item_type__gtin__contains: this.filters.gtin,
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage,
        });
      }

      this.ordersCount = data.count;
      this.data = data.results.map((item) => {
        return {
          gtin: item.gtin,
          theorical_quantity: item.theorical_quantity,
          stockRatingPercent:
            item.theorical_quantity < item.quantity
              ? (item.theorical_quantity / item.quantity) * 100
              : (item.quantity / item.theorical_quantity) * 100,
          ismore: item.theorical_quantity < item.quantity,
          quantity: item.quantity,
          season: item.season,
          section: item.section,
          model: item.model,
          description: item.description,
          size: this.parseSizes(item.sizes),
          colour: item.colour,
        };
      });

      this.columns = [
        {
          field: "gtin",
          label: this.$t("lang.inventory.detail.table_field_1"),
          width: "120",
          filter: {
            placeholder: this.$t(
              "lang.inbound.dashboard.table_field_placeholder_4"
            ),
            value: this.filters.gtin,
          },
        },
        {
          field: "description",
          label: this.$t("lang.inventory.detail.description"),
        },
        {
          field: "season",
          label: this.$t("lang.inventory.detail.table_field_2"),
        },
        {
          field: "section",
          label: this.$t("lang.inventory.detail.table_field_3"),
        },
        {
          field: "model",
          label: this.$t("lang.inventory.detail.table_field_4"),
        },
        {
          field: "size",
          label: this.$t("lang.inventory.detail.table_field_5"),
        },
        {
          field: "colour",
          label: this.$t("lang.inventory.detail.table_field_6"),
        },
        {
          field: "stockRating",
          label: this.$t("lang.inventory.detail.table_field_7"),
          centered: true,
        },
        {
          field: "quantity",
          label: this.$t("lang.inventory.detail.table_field_8"),
          centered: true,
          width: "120",
        },
      ];

      this.shouldLoading = false;
    },
    onClick(mode) {
      this.mode = mode;
      this.confirmDialog = true;
    },
    onConfirmation() {
      if (this.mode === "sendUnvalidation") {
        this.sendUnvalidation();
      } else {
        this.sendValidation();
      }
    },
    onCancel() {
      this.confirmDialog = false;
    },
    sendValidation() {
      this.$api.inventories.validate(this.id).then((res) => {
        this.validationMode = true;
        this.getData();
        this.onCancel();
      });
    },
    cancelValidation() {
      this.validationMode = false;
      this.getData();
    },
    sendUnvalidation() {
      this.$api.inventories.unvalidate(this.id).then((res) => {
        this.validationMode = true;
        this.getData();
        this.onCancel();
      });
    },
  },
  mounted() {
    this.getData();
    this.filters.gtin = this.$session.get(this.key + "gtin");
  },
};
</script>
<style scoped>
@media screen and (min-width: 768px) {
  .btn-validation {
    width: 130px;
    float: right;
  }
}
</style>
